







































import { sleep } from "@root/lib/utils";
import {
  Component,
  Prop,
  Vue,
  Mixins,
  Watch,
  InjectReactive
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
const productCreate = namespace("productCreate");
@Component({
  components: {}
})
export default class channelSkuMediaDialog extends Vue {
  @productCreate.Action uploadChannelImage;
  @InjectReactive("curChannel") curChannel;
  visible = false;
  @Prop({ default: () => [] }) dataValue; // 需要回显的值
  @Prop({ default: () => "" }) node; // 编辑节点的
  mediaTempData: any = [];
  private acceptType =
    "image/webp,image/bmp,image/gif,image/jpeg,image/jpg,image/png,video/*";
  max = 8;
  mediaTemp(data) {
    this.mediaTempData = data;
  }
  @Watch("dataValue")
  watchDataValue(val) {
    console.log(val);

    this.mediaTempData = val || [];
  }
  // op图片上传成功之后
  async uploadChannel(fileUrl) {
    let url = await this.uploadChannelImage({
      input: {
        image: fileUrl,
        shopCode: this.curChannel.value,
        channelCode: this.curChannel.channelCode
      }
    });
    return url;
  }
  async onsuccess([fileUrl, fileList]) {
    this.mediaChange(fileList);
  }
  onRemove([index, fileList]) {
    this.mediaChange(fileList);
  }
  dragEnd([fileList]) {
    this.mediaChange(fileList);
  }
  mediaChange(fileList) {
    this.mediaTempData = fileList.map(item => item.url);
  }
  mediaSubmit() {
    this.$emit("changeSkuMedia", this.mediaTempData);
    this.visible = false;
  }
}
